import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ServiceOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ServiceOrder/ServiceOrderBrowser")
	}

	render() {
		return (
			<Activity 
				name="ServiceOrder"
				RenderedComponent={this.RenderedComponent}
				context="ServiceOrder"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ServiceOrderActivity)
